import { render, staticRenderFns } from "./SelectStatusStockAdjust.vue?vue&type=template&id=6f20c49e&scoped=true&"
import script from "./SelectStatusStockAdjust.vue?vue&type=script&lang=js&"
export * from "./SelectStatusStockAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20c49e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
